import { writable } from "svelte/store";

const defaultContext = {
  enabled: false,
  page: "task explorer",
  title: "This view",
  task: "Understand the purpose of this view and find the next useful action.",
  starterQuestions: [
    "What should I do here first?",
    "Explain this view",
    "What should I pay attention to?",
  ],
};

export const paxbotHelpContext = writable(defaultContext);

export function setPaxbotHelpContext(context) {
  paxbotHelpContext.set({
    ...defaultContext,
    ...context,
    enabled: Boolean(context?.task && context?.title),
  });
}

export function clearPaxbotHelpContext() {
  paxbotHelpContext.set(defaultContext);
}
